import FormError from '@/shared-components/error/components/FormError';

import EditArtwork from './components/EditArtwork';
import SubmitArtworkDraft from './components/SubmitArtworkDraft';

import './index.css';

export default function SubmitButton({ 
  formState, 
  editMode, 
  formError, 
  setFormError, 
  termsAccepted, 
  auctionAgreementAccepted,
  onInvalidStep,
  initialState        
}) { 
  return (
    <>
      <input type="hidden" id="artwork_generic_error" />
      <FormError error={formError} element="artwork_generic_error" />

      {editMode ? (
        <EditArtwork 
          formState={formState} 
          setFormError={setFormError}  
          initialState={initialState} 
        />
      ) : (
        <SubmitArtworkDraft 
          formState={formState} 
          setFormError={setFormError}
          termsAccepted={termsAccepted}
          auctionAgreementAccepted={auctionAgreementAccepted}
          onInvalidStep={onInvalidStep}
        />
      )}
    </>
  );
}
